<template>
  <div class="page-query">
    <TableQuery title="发货计划调整查询" @search="queryData" @reset="reset">
      <el-form inline class="form" size="medium" label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="申请单号">
              <el-input v-model="conditions.billCode" placeholder="请输入单号" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户名称">
              <el-input
                v-model="conditions.customerName"
                suffix-icon="el-icon-more"
                @clear="conditions.partner = ''"
                @focus="openDialog($event, '客户选择')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="营销中心">
              <el-input
                v-model="conditions.saleCenterView"
                @clear="conditions.zyxdy = ''"
                @focus="openDialog($event, '营销中心')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="渠道类型">
              <el-select v-model="conditions.zqdlx">
                <el-option
                  v-for="item in selectDataOptions['goodsPlanType']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产品名称">
              <el-input
                v-model="conditions.productName"
                suffix-icon="el-icon-more"
                @clear="conditions.productId = ''"
                @focus="openDialog($event, '产品选择')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计划年度">
              <el-date-picker
                v-model="conditions.pyear"
                value-format="yyyy"
                format="yyyy"
                type="year"
                placeholder="选择年"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </TableQuery>
    <div class="table-container">
      <TableCommon
        title="明细"
        :custome-config="() => vxeShowCustom('xTable')"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
      >
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="500"
          align="center"
          size="medium"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #operation="{ row }">
            <span class="blue" @click="showHistory(row)">调整历史查看</span>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog v-dialogDrag :title="dialogTitle" :visible.sync="showDialog" width="70%" :append-to-body="true">
      <template v-if="showDialog">
        <org-select v-if="dialogTitle === '营销中心'" ref="dialogSelect" />

        <client-select v-if="dialogTitle === '客户选择'" ref="dialogSelect" />
        <product-select v-if="dialogTitle === '产品选择'" ref="dialogSelect" />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >提交</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag :visible.sync="historyDialog" title="发货计划调整历史" width="70%">
      <monthly-history v-if="historyDialog" :row-data="currentRow" />
    </el-dialog>
  </div>
</template>

<script>
import ActionUtils from '@/utils/action'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiMonthPlanFindList } from '@/api/applyForGoods/monthly'
import MonthlyHistory from './components/MonthlyHistory.vue'

const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
const OrgSelect = () => import('@/components/dialog/OrgSelect.vue')
const ProductSelect = () => import('@/components/dialog/ProductSelect.vue')
export default {
  components: {
    ClientSelect,
    OrgSelect,
    ProductSelect,
    MonthlyHistory
  },
  data() {
    return {
      dialogTitle: '客户选择',
      showDialog: false,
      historyDialog: false,
      currentRow: {},
      conditions: {
        zyxdy: '',
        saleCenterView: '',
        billCode: '',
        customerName: '',
        partner: '',
        productId: '',
        zqdlx: '',
        productName: '',
        pyear: new Date().getFullYear().toString()
      },
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0,
        loadingOptions: [
          { target: '.table-block', text: '数据加载中...' }
        ]
      },
      gridOptions: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'partner', title: '客户编码', width: 120 },
          { field: 'name', title: '客户名称', width: 120 },
         // { field: '11', title: '全年计划量', width: 120 },
          { field: 'productId', title: '产品编码', width: 120 },
          { field: 'productName', title: '产品名称', width: 120 },
          { field: 'zqdlxTextView', title: '渠道类型', width: 120 },
          { field: 'qdjhl', title: '渠道计划量', width: 120 },
          { field: 'zyxdy', title: '营销单元', width: 120 },
          { field: 'zyxdyName', title: '营销单元名称', width: 120 },
          { field: 'annual', title: '实际年度', width: 120 },
          { field: 'monthly', title: '月份', width: 120 },
          { field: 'deliveryNum', title: '计划量', width: 120 },
          { field: 'approvingNum', title: '发货量(审核中)', width: 120 },
          { field: 'usedNum', title: '发货量(归档)', width: 120 },
          { field: 'remainNum', title: '剩余量', width: 120 },
          { field: 'operation', title: '操作', width: 120, slots: { default: 'operation' }}
        ],
        data: []
      },
      selectDataOptions: {}
    }
  },
  created() {
    this.getSelectDictDataOrigin('goodsPlanType')
    this.queryData()
  },
  methods: {
    async queryData() {
      this.loading = true
      const params = { ...this.pagination, ...this.conditions }
      try {
        const { data: { Rows, Total }} = await apiMonthPlanFindList(params)
        console.log(Rows)
        this.gridOptions.data = Rows
        this.pagination.totalCount = Total
      } catch (e) {
        console.log(e)
      }
      this.loading = false
    },
    reset() {
      this.conditions = {
        zyxdy: '',
        saleCenterView: '',
        billCode: '',
        customerName: '',
        partner: '',
        productId: '',
        zqdlx: '',
        productName: '',
        pyear: new Date().getFullYear().toString()
      }
    },
    handleTablePaginationChange(page) {
      ActionUtils.setPagination(this.pagination, page)
      if (this.queryData) {
        this.queryData()
      }
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()

      if (!data) return

      if (this.dialogTitle === '客户选择') {
        this.conditions.partner = data.partner
        this.conditions.customerName = data.customerName
      } else if (this.dialogTitle === '产品选择') {
        this.conditions.productId = data.productId
        this.conditions.productName = data.productShortName
      } else {
        this.conditions.zyxdy = data.code
        this.conditions.saleCenterView = data.name
      }
      this.showDialog = false
    },
    showHistory(row) {
      this.currentRow = row
      this.historyDialog = true
    },
    openDialog(e, title) {
      e.target.blur()
      this.showDialog = true
      this.dialogTitle = title
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/deliveryPlanChangeQuery.vue